export const baseURL = process.env.REACT_APP_BASE_URL!;
